import React from 'react';

const DESPACHO_URL = import.meta.env.VITE_API_DESPACHO;

const AttachmentContent = ({element, colSpan = 5}) => {
    if (!element) return null;

    return (
        <tr className="export-ignore">
            <td colSpan={colSpan}>
                <div className="flex flex-row justify-center gap-4">
                    {element.map((attachment, index) => {
                        const imageSrc = DESPACHO_URL + "/attachment/print/" + attachment;

                        return (
                            <div key={index} className="w-fit flex justify-center border border-gray-300">
                                <a href={imageSrc} target="_blank">
                                    <img src={imageSrc} className="h-[350px] object-contain" alt="Imagem" title={"Abrir imagem em outra guia"}/>
                                </a>
                            </div>
                        );
                    })}
                </div>
            </td>
        </tr>
    );
};

export default AttachmentContent;